import { heroContent } from "@/mocks/content";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20composition%20with%20interlocking%20geometric%20shapes%20in%20warm%20terracotta%20amber%20and%20cream%20tones%2C%20delicate%20grid%20patterns%20suggesting%20organized%20data%20and%20spreadsheet%20structures%2C%20soft%20glowing%20light%20rays%20streaming%20diagonally%20across%20the%20frame%2C%20subtle%20product%20silhouettes%20of%20shoes%20bags%20and%20accessories%20emerging%20from%20the%20abstract%20geometry%2C%20sophisticated%20editorial%20design%20with%20rich%20textural%20layers%2C%20refined%20minimalist%20aesthetic%20with%20organic%20flowing%20forms%20and%20structured%20elements%20coexisting%20harmoniously&width=1600&height=900&seq=hero-v2-2026-jul&orientation=landscape"
        alt="Hipobuy Spreadsheet product research database and shopping intelligence platform"
        title="Hipobuy Spreadsheet - Product Research Database"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6 md:mb-8">
          <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
          <span className="text-xs md:text-sm text-background-50 font-medium tracking-wide">
            Updated Spreadsheet Resources
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-4 md:mb-6">
          {heroContent.headline}
        </h1>

        <p className="text-sm md:text-lg text-background-200 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          {heroContent.subheadline}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-10 md:mb-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-primary-500 text-white text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25 hover:shadow-primary-500/40 hover:-translate-y-0.5"
          >
            {heroContent.primaryCTA}
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl border-2 border-background-50/50 text-background-50 text-sm md:text-base font-semibold hover:bg-background-50 hover:text-foreground-900 transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            {heroContent.secondaryCTA}
            <i className="ri-external-link-line ml-2"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5">
          {heroContent.trustItems.map((item, i) => (
            <div key={i} className="flex items-center gap-1.5 text-background-200 text-xs md:text-sm">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
              </div>
              {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}